'use client';

import React, { useCallback, useState } from 'react';
import { SearchModes } from '@/domainLogic/index.ts';
import { IconAbtot } from '@lmn/lastminute-react-icons/lastminute-icons-linear.js';
import { IconAtol } from '@lmn/lastminute-react-icons/lastminute-icons-solid.js';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation';
import PopoverOrModal from '@/app/common/components/PopoverOrModal';
import { GrayButton } from '../ResultsHeaderLayout/styled.ts';

const AtolIcon = () => <IconAtol aria-hidden="true" size="40" />;
const AbtotIcon = () => <IconAbtot aria-hidden="true" size="40" />;

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PopoverText = styled.p`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  margin: 0;
`;

const PopoverLink = styled.a`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  text-decoration: underline;
`;

const AtolBadge = ({ disabled, usePortal }: { disabled?: boolean; usePortal?: boolean }) => {
  const { localization, searchInfoData } = usePageWrapperData();
  const { isMobile } = useCommonClient();
  const { searchMode } = searchInfoData;
  const { t } = useTranslation();
  const isTrain = searchMode === SearchModes.TH;
  const atolLink = localization?.configValuesApp?.atolLink;

  const [buttonEl, setButtonEl] = useState<HTMLSpanElement | null>(null);
  const buttonRef = useCallback((node: HTMLSpanElement | null) => setButtonEl(node), []);

  const label = isTrain
    ? t('vacation.select.abtot.protected')
    : t('vacation.oss.components.searchresults.tour_tile.atolProtected');

  return (
    <>
      <span ref={buttonRef}>
        <GrayButton
          appearance="ghost"
          variant="primary"
          iconTrailing={isTrain ? AbtotIcon : AtolIcon}
          disabled={disabled}
        >
          {label}
        </GrayButton>
      </span>
      <PopoverOrModal
        anchorEl={buttonEl}
        isMobile={isMobile}
        align="right"
        usePortal={usePortal}
        aria-label={label}
        title={label}
        id={isTrain ? 'abta-badge-modal' : 'atol-badge-modal'}
      >
        <PopoverContent>
          <PopoverText>{isTrain ? t('vacation.oss.abta.popover') : t('vacation.oss.atol.popover')}</PopoverText>
          {atolLink && (
            <PopoverLink href={atolLink} target="_blank" rel="nofollow noopener noreferrer">
              {t('vacation.oss.learn_more')}
            </PopoverLink>
          )}
        </PopoverContent>
      </PopoverOrModal>
    </>
  );
};

export default AtolBadge;
